/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Signal_Salary_MentionedInputs */

const en_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const de_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const fr_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const es_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const it_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const nl_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const pl_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const fi_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const da_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

const sv_negotiation_signal_salary_mentioned = /** @type {(inputs: Negotiation_Signal_Salary_MentionedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary mentioned`)
};

/**
* | output |
* | --- |
* | "Salary mentioned" |
*
* @param {Negotiation_Signal_Salary_MentionedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_signal_salary_mentioned = /** @type {((inputs?: Negotiation_Signal_Salary_MentionedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Signal_Salary_MentionedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_signal_salary_mentioned(inputs)
	if (locale === "fr") return fr_negotiation_signal_salary_mentioned(inputs)
	if (locale === "es") return es_negotiation_signal_salary_mentioned(inputs)
	if (locale === "it") return it_negotiation_signal_salary_mentioned(inputs)
	if (locale === "nl") return nl_negotiation_signal_salary_mentioned(inputs)
	if (locale === "pl") return pl_negotiation_signal_salary_mentioned(inputs)
	if (locale === "fi") return fi_negotiation_signal_salary_mentioned(inputs)
	if (locale === "da") return da_negotiation_signal_salary_mentioned(inputs)
	if (locale === "sv") return sv_negotiation_signal_salary_mentioned(inputs)
	return en_negotiation_signal_salary_mentioned(inputs)
});